
import { defineComponent, SetupContext, PropType } from "vue";
import NativeClient from "@/client/native-client";
import {} from "@/types/pantry";
import { CommonRecipe } from "@/types/commonRecipe";
import CommonHorizontalRecipeList from "@/components/commonRecipe/CommonHorizontalRecipeList.vue";

export default defineComponent({
  name: "PantryRecommendView",
  components: {
    CommonHorizontalRecipeList
  },
  props: {
    recipes: {
      type: Array as PropType<CommonRecipe[]>,
      default: () => []
    },
  },
  setup(props, context: SetupContext) {
    /**
     * 選択されたレシピをNativeに通知する
     */
    const selectRecipe = (id: number, type: string) => {
      NativeClient.sendDebugLog("selectRecipe id=" + id + " type=" + type);
      context.emit("select-recipe", id, type);
    };
    return {
      selectRecipe,
    };
  }
});
